export default __webpack_public_path__ + "static/media/callingcode-regular-webfont.b199e327.ttf";